import * as React from "react";
import Layout from "../layouts";
var NotFoundPage = function NotFoundPage() {
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("h1", null, "404 Not Found"));
};
export default NotFoundPage;
